import { useState } from "react";

import { api, ApiError, type Fetcher } from "../api/client";
import { DateHint, PAST_DATE_BOX } from "./DateHint";

/**
 * NEW PERSONAL TASK on My work (punch list F171, Jeremy 1 Nov 2026): a task
 * only the person making it will ever see, in their personal project, on the
 * Whiteboard workflow with them on every stage. The server decides all of
 * that (db/personal-tasks.ts); this asks only what New task asks first -- the
 * title and the due date, in New task's own words.
 */
export function NewPersonalTask({ fetcher, onCreated }: { fetcher: Fetcher; onCreated: (taskId: string) => void }) {
  const [title, setTitle] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setSaving(true);
    try {
      const task = await api.createPersonalTask(fetcher, { title, dueDate: dueDate || null });
      onCreated(task.id);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : String(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="card personal-task-form" onSubmit={submit}>
      <h2>New personal task</h2>
      {error ? <div className="error">{error}</div> : null}
      <div className="field">
        <label htmlFor="pt-title">Title</label>
        <input id="pt-title" value={title} onChange={(e) => setTitle(e.target.value)} required autoFocus />
      </div>
      <div className="field">
        <label htmlFor="pt-due">Task final due date</label>
        <input
          id="pt-due"
          type="date"
          {...PAST_DATE_BOX}
          value={dueDate}
          onChange={(e) => setDueDate(e.target.value)}
        />
        <DateHint />
      </div>
      <button className="primary" type="submit" disabled={saving}>
        {saving ? "Creating…" : "Create task"}
      </button>
    </form>
  );
}
